import BaseAPI from './base/base-api';

class SystemNotificationAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'ManagementAPI';
    controllerName = 'systemnotification';
}

export default new SystemNotificationAPI();